import React from 'react';
import { Breakpoints, MQ, MQ_NOT_TOUCH } from 'style/styled-components/cssMediaQueries';
import { styled } from 'components/ThemeConfigConnector/ThemeConfigConnnector';
import { headerZIndex } from 'style/styled-components/cssGlobalVariables';
import { LinkTrackable } from 'components/Trackable/LinkTrackable';
import { DropdownItemSimpleWrapper } from 'components/DropdownMenu/DropdownMenu.css';
import { buttonReset } from 'style/styled-components/cssButtonReset';

export const ExternalLink = styled.a<{ active?: string }>`
    color: ${(props) => props.theme.brandedConfig.high_contrast};
    opacity: ${(props) => (props.active ? '1.0' : '0.66')};

    &:focus-visible {
        border-bottom: 2px solid ${(props) => props.theme.brandedConfig.high_contrast};
        margin-bottom: -2px;
        transition: none;
    }
`;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const InternalLink = styled(({ to, active, ...rest }) => <LinkTrackable to={to} {...rest} />)<{ active?: string; to: string }>`
    color: ${(props) => props.theme.brandedConfig.high_contrast};
    opacity: ${(props) => (props.active ? '1.0' : '0.66')};

    &:focus-visible {
        border-bottom: 2px solid ${(props) => props.theme.brandedConfig.high_contrast};
        margin-bottom: -2px;
        transition: none;
    }
`;

export const LinksBlock = styled.nav`
    position: relative;
    ${InternalLink}, ${ExternalLink} {
        display: block;
        vertical-align: middle;
        font-size: 14px;
        line-height: 20px;

        &:hover {
            opacity: 1;
        }
    }
`;

export const LanguageDropdownWrapper = styled.div`
    ${DropdownItemSimpleWrapper} {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        gap: 8px;

        .colored {
            position: relative;
            top: 0;
            transform: none;
            right: 0;
            width: 32px;
            height: 32px;
            border-radius: 50%;
            overflow: hidden;

            svg {
                position: relative;
                left: -50%;
                width: auto;
                height: 100%;
            }
        }
    }
`;

export const LanguageDropdownButton = styled.button`
    ${buttonReset}
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    gap: 12px;
    height: 30px;
    cursor: pointer;
    opacity: 0.8;
    transition: opacity 0.2s ease-out;

    svg {
        width: 20px;
    }

    .chevron {
        margin-top: -2px;

        svg {
            width: 14px;
            transform: scale(-1, -1);
        }

        &.is-open {
            svg {
                transform: none;
            }
        }
    }

    &:focus-visible {
        outline: var(--focus-outline);
    }

    ${MQ_NOT_TOUCH} {
        &:hover {
            opacity: 1;
        }
    }
`;

export const FooterWrapper = styled.footer`
    position: relative;
    height: 48px;
    display: none;
    width: 100%;
    line-height: 24px;
    z-index: ${headerZIndex};
    text-align: left;
    background-color: ${(props) => props.theme.brandedConfig.background};
    border-top: 1px solid var(--color-neutral-dark-body-10);

    ${MQ(Breakpoints.xs)} {
        ${LinksBlock} {
            display: inline-block;
            width: auto;

            ${InternalLink}, ${ExternalLink} {
                margin-right: 24px;
                display: inline-block;
                vertical-align: middle;
            }

            hr {
                margin: 0;
                width: 100%;
                float: left;
            }
        }
    }

    ${MQ(Breakpoints.s)} {
        padding: 0px 72px;
    }

    ${MQ(Breakpoints.m)} {
        display: flex;
        justify-content: space-between;
        padding-top: 6px;
    }
`;
